import { Component } from '@verndale/core';
import { KEYS } from '../constants';
import { isDescendant } from '../helpers';
import { focusableElements } from '../helpers';

class Module extends Component {
  setupDefaults() {
    this.videoId = this.el.dataset.videoId;
    this.modal = this.el.closest('.modal__content');
    this.dom = {
      $poster: this.el._$('.video__thumbnail'),
      $thumbContainer: document._$('.video-list__slide-thumbs')
    };

    this.isThumb = isDescendant(this.dom.$thumbContainer, this.el);
  }

  addListeners() {
    if (this.isThumb) return;
    this.el._on('click', this.initVideo.bind(this));
    this.el._on('keydown', this.handleKeyDown.bind(this));
  }

  handleKeyDown(e) {
    if (!this.modal && document.getElementById(`vframe-${this.videoId}`)) return;
    if (e.keyCode === KEYS.ENTER || e.keyCode === KEYS.SPACE) {
      this.initVideo();
    }
  }

  initVideo(e = null) {
    if (e && !e.target.closest('.video__container')) return; // only if it gets triggered by clicking/tapping
    if (!this.modal && document.getElementById(`vframe-${this.videoId}`)) return;

    const iframe = document.createElement('iframe');

    iframe.setAttribute('width', '100%');
    iframe.setAttribute('height', '100%');
    iframe.setAttribute('frameborder', 0);
    iframe.setAttribute('allow', 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; fullscreen');
    iframe.setAttribute('id', `vframe-${this.videoId}`);
    iframe.setAttribute('title', `Youtube video ${this.videoId}`);
    iframe.setAttribute('allowfullscreen', true);
    iframe.setAttribute(
      'src',
      `https://www.youtube.com/embed/${this.videoId}?modestbranding=1&rel=0&showinfo=0&autohide=1&autoplay=1&mute=1&enablejsapi=1`
    );

    this.dom.$poster?.parentNode.appendChild(iframe);

    iframe.onload = () => {
      this.dom.$poster?.parentNode._$$(focusableElements)[0]?.focus();
    }
  }
}

export default Module;
